import { I } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-htmlthanks',
  templateUrl: './htmlthanks.component.html',
  styleUrls: ['./htmlthanks.component.scss']
})
export class HTMLThanksComponent implements OnInit {
  isCancel: any=false;

  constructor(private route: ActivatedRoute,private router: Router) {
    if(this.router.getCurrentNavigation().extras.state!=undefined && this.router.getCurrentNavigation().extras.state!=null)
         this.isCancel= this.router.getCurrentNavigation().extras.state.isCancel;
     
  } 

  ngOnInit(): void {
  }


}
